import { render, staticRenderFns } from "./Activity1.vue?vue&type=template&id=3fb62623&scoped=true"
import script from "./Activity1.vue?vue&type=script&lang=js"
export * from "./Activity1.vue?vue&type=script&lang=js"
import style0 from "./Activity1.vue?vue&type=style&index=0&id=3fb62623&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb62623",
  null
  
)

export default component.exports